

























import {Component, Vue} from "vue-property-decorator";
import CategoryService, {CategoryDto, ICategory} from "@/services/category.service";
import ImageUploader from "@/components/ui/ImageUploader.vue";
import {Project, ProjectService} from "@/services/project.service";
import CardCollapsible from "@/components/ui/CardCollapsible.vue";

@Component({name: "ProjectManager", components: {ImageUploader, CardCollapsible}})
export default class ProjectManager extends Vue {
    private initialized = false;
    private projects!: Project[];
    private projectService!: ProjectService;

    private async mounted () {
        this.projectService = new ProjectService();
        await this.refresh();
        this.initialized = true;
    }

    private async refresh() {
        const res = await this.projectService.get();
        if (res.success) this.projects = res.result;
        else this.projects = [];
    }

    private async deleteProject(projectId: string) {
        await this.projectService.delete(projectId);
        await this.refresh();
        this.$forceUpdate();
    }
}
